export default "__VITE_ASSET__s9_$rHLQ__"